<template>

  <div style="height:100%">
    <Row :gutter="16" style="height: calc(100% - 20px)">

      <Col span="8" style="height: calc(100% - 20px)">
      <div class="block" style="height: 50%">
        <h2 class="title">
          今日趟次记录
        </h2>
        <div class="chartWrap">
          <youhao ref="youhao"></youhao>
        </div>
      </div>
      <div class="block" style="height: 50%">
        <h2 class="title">
          当月趟次汇总
        </h2>
        <div class="chartWrap">
          <licheng ref="licheng"></licheng>
        </div>
      </div>
      </Col>
      <Col span="16" style="height: calc(100% - 20px)">
      <div class="block" style="height: 100%">
        <h2 class="title">
          趟次出车分布
        </h2>
        <div class="chartWrap">
          <ecmap ref="ecmap"></ecmap>
        </div>
      </div>
      </Col>

    </Row>

    
  </div>
</template>
<script>
import startEnd from "./statrEnd.vue";
import youhao from "./youhao.vue";
import licheng from "./licheng.vue";
import xunchache from "./xunchache.vue";
import saodiche from "./saodiche.vue";
import zongzichan from "./pie";
import ecmap from "./ecmap.vue";
import paigongzonglan from "./paigongzonglan.vue";
import cheliangbaojing from "./cheliangbaojing.vue";
import paigongxiangmu from "./paigongxiangmu.vue";
import mapMenu from "./mapMenu.vue";
export default {
  components: {
    zongzichan,
    startEnd,
    youhao,
    licheng,
    xunchache,
    saodiche,
    ecmap,
    paigongzonglan,
    cheliangbaojing,
    paigongxiangmu,
    mapMenu,
  },

  data() {
    return {};
  },
  methods: {
    reMapMenu(v, m) {
      return;
      if (m == "巡查点") {
        setTimeout(() => {
          this.$refs.ecmap.showLjt(v);
        }, 1500);
      } else if (m == "作业人员") {
        setTimeout(() => {
          this.$refs.ecmap.showpersons(v);
        }, 1500);
      } else if (m == "扫地车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showXisao(v);
        }, 1500);
      } else if (m == "作业网格") {
        this.$refs.ecmap.showWangge(v);
      } else if (m == "巡查车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showQingyun(v);
        }, 1500);
      } else if (m == "作业线路") {
        setTimeout(() => {
          this.$refs.ecmap.showline(v);
        }, 500);
      }
    },
    groups(v) {
      if (v[0].name == "广东华政建设有限公司") {
        v = [];
      }
      //this.$refs.paigongxiangmu.groups(v);
      //this.$refs.paigongzonglan.groups(v);
      // this.$refs.licheng.groups(v);
      //this.$refs.youhao.groups(v);
      //this.$refs.zongzichan.getData(v);
      //this.$refs.mapMenu.groups(v);
    },
  },
  computed: {},

  mounted() {
    //let screenWidth = window.innerWidth;

  },
};
</script>

<style lang="">
#big {
  width: 1920px;
  height: 1080px;
  padding: 0 16px;
  transform-origin: 0 0;
}
#big p,
#big div {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/tangci/index.vue